import React from 'react';
import { useHistory } from 'react-router';
import qs from 'qs'

// mui
import { Grid, MenuItem, TextField } from '@mui/material';

// block groups
import TableWithSearch from "../../../../../blockGroups/table/TableWithSearch/TableWithSearch.blockgroup";

// utils
import { cleanEquipmentRequestData } from './EquipmentRequestListWithSearch.collection.utils';
import { dateComparator } from '../../../../../shared/sorting/dates';
import { useTableSort } from '../../../../../shared/hooks/useTableSort';
import { useTableFilter } from '../../../../../shared/hooks/useTableFilter';

const EquipmentSearchFieldOptions = [
    {value: "job", title: "Job"},
    {value: "requestedBy", title: "Requested By"}
];

const equipmentRequestFilterFieldOptions = [
    { value: "Submitted", title: "Submitted" },
    { value: "Shipped", title: "Shipped" },
    { value: "A", title: "All" }
]

const EquipmentColumnConfigs = [
    { 
        name: "job", 
        title: "Job", 
        objectFieldsToDisplay: ["job"],
        objectFieldsDelimeter: "", 
        useNestedObject: false
    },
    { 
        name: "status", 
        title: "Status", 
        objectFieldsToDisplay: ["status"],
        objectFieldsDelimeter: "", 
        useNestedObject: false
    },
    { 
        name: "requestedBy", 
        title: "Requested By", 
        objectFieldsToDisplay: ["requestedBy"],
        objectFieldsDelimeter: "", 
        useNestedObject: false
    },
    { 
        name: "numItems", 
        title: "# of Items", 
        objectFieldsToDisplay: ["numItems"],
        objectFieldsDelimeter: "", 
        useNestedObject: false,
        type: 'number',
        align: 'left',
        headerAlign: 'left'
    },
    { 
        name: "dateRequested", 
        title: "Date Requested", 
        objectFieldsToDisplay: ["dateRequested"],
        objectFieldsDelimeter: "", 
        useNestedObject: false,
        type: 'date',
        sortComparator: dateComparator
    },
    { 
        name: "datetimeFulfilled", 
        title: "Date Fulfilled", 
        objectFieldsToDisplay: ["datetimeFulfilled"],
        objectFieldsDelimeter: "", 
        useNestedObject: false,
        type: 'date',
        sortComparator: dateComparator
    },
];

const EquipmentRequestListWithSearch = ({data = { allEquipmentRequests: [] }, loading, error, pageProps}) => {
    const history = useHistory()
    const filterBy = useTableFilter(pageProps.location.search, "Submitted")
    const sortModel = useTableSort(pageProps.location.search, { field: "dateRequested", sort: "desc"})

    const handleSortChange = (newSortModel) => {
        if(newSortModel.length > 0) {
            history.push(`/inventory/equipment-requests?sortField=${newSortModel[0].field}&sortDirection=${newSortModel[0].sort}&filterBy=${filterBy}`)
        } else {
            history.push(`/inventory/equipment-requests?sortField=${""}&sortDirection=${""}&filterBy=${filterBy}`)
        }
    }
    const setFilterBy = (newFilter) => {
        if(sortModel.length > 0) {
            history.push(`/inventory/equipment-requests?sortField=${sortModel[0].field}&sortDirection=${sortModel[0].sort}&filterBy=${newFilter}`)
        } else {
            history.push(`/inventory/equipment-requests?sortField=${""}&sortDirection=${""}&filterBy=${newFilter}`)
        }
    }

    
    const cleanedData = [...cleanEquipmentRequestData(data.allEquipmentRequests, filterBy)]

    const handleRowClick = (rowData) => {
        history.push(`/inventory/equipment-requests/${rowData.id}`)
    }
    
    return (<Grid container>
        <Grid item>
            <TextField 
                select
                size={'small'}
                value={filterBy}
                onChange={(e) => setFilterBy(e.target.value)}
                fullWidth
                sx={{ marginBottom: 4}}
                defaultValue={"submitted"}
            >
                {
                    equipmentRequestFilterFieldOptions.map(option => {
                        return (<MenuItem key={option.value} value={option.value}>{option.title}</MenuItem>)
                    })
                }
            </TextField>
        </Grid>
        <TableWithSearch
            rawData={cleanedData}
            loading={loading}
            error={error}
            searchFieldOptions={EquipmentSearchFieldOptions}
            columnConfigs={EquipmentColumnConfigs}
            onRowClick={handleRowClick}
            sortModel={sortModel}
            onSortModelChange={handleSortChange}
            pageProps={pageProps}
        />
    </Grid>
        
    );
}

export default EquipmentRequestListWithSearch;